import { Pipe, PipeTransform, PLATFORM_ID, Inject, ElementRef } from '@angular/core';
import { Image } from "angular-engine/model/api.model";
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

@Pipe({ name: 'peopleImage' })
export class PeopleImagePipe implements PipeTransform {
    transform(item: any): string {
        const meta = item.meta || item;
        let image:any = meta.images.find((obj) => { return obj.name == "people_thumb_416x" });

        if(image == null && meta.series)
        {
            image = meta.series.images.find((obj) => { return obj.name == "people_thumb_416x" });
        }

        if(image == null)
        {
            image = meta.images.find((obj) => { return obj.name == "thumb_416x" });
        }

        if(image == null)
        {
            return '/images/Default.jpg';
        }

        return image.url;
    }
}

@Pipe({ name: 'imageWidth' })
export class ImageWidthPipe implements PipeTransform {
    transform(value: Image): string {
        return value.size.split("x")[0];
    }
}

@Pipe({ name: 'imageHeight' })
export class ImageHeightPipe implements PipeTransform {
    transform(value: Image): string {
        return value.size.split("x")[1];
    }
}

@Pipe({ name: 'imageSelector' })
export class ImageSelectorPipe implements PipeTransform {
    private isServer = false;
    private window: any;
    constructor(
        @Inject(PLATFORM_ID) platformId: string
    ) {
        this.isServer = isPlatformServer(platformId);
    }

    transform(images: Image[], name: string, fallback): Image {
        if (name) {
            let image = this.getImageByName(images, name);
            if (image && image.url) {
                return image;
            }
            else if (fallback) {
                return this.getImageByName(images, fallback);
            }
            else {
                return {} as Image;
            }
        }

        var largestImage: Image = images[0];
        var largestImageWidth = 0;
        var windowWidth = 0;

        for (let image of images) {
            let imageWidth = parseInt(image.size.split("x")[0], 10);

            if (this.isServer) {
                if (imageWidth == 1920) {
                    return image;
                }
            }
            else {
                windowWidth = window.innerWidth * window.devicePixelRatio;
                if (imageWidth < windowWidth) {
                    if (imageWidth > largestImageWidth) {
                        largestImage = image;
                        largestImageWidth = imageWidth;
                    }
                }
            }
        }

        return largestImage;
    }

    private getImageByName(images: Image[], name: string) {
        let image = images.find((i) => { return name === i.name });
        return image;
    }
}



// WEBPACK FOOTER //
// ./src/angular-shared-features/feature/custom-image/image.pipe.ts